import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole?: 'admin' | 'vendor' | 'dev';
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-muted-foreground">Chargement...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Check for required role
  if (requiredRole) {
    const userRole = profile?.role as string | undefined;
    
    // Admin and dev can access everything
    if (userRole === 'admin' || userRole === 'dev') {
      return <>{children}</>;
    }
    
    // For vendor routes, only vendors can access
    if (requiredRole === 'vendor' && userRole !== 'vendor') {
      return <Navigate to="/" replace />;
    }
    
    // For admin routes, redirect non-admins
    if (requiredRole === 'admin') {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
